import { ApiService } from 'react-angle-dashboard-components'
import { Member, MemberDTO } from '../../interfaces/member'

const mapMembersToDTO = (members: Member[]): MemberDTO[] => {
  if (members?.length === 0) return []

  return members.map((member) => ({
    last_name: member.lastName,
    employee_index: member.employeeIndex,
    work_email: member.email
  }))
}

const mapDTOToMembers = (membersDTO: MemberDTO[]): Member[] => {
  if (membersDTO?.length === 0) return []

  return membersDTO.map((dto) => ({
    lastName: dto.last_name,
    email: dto.work_email,
    employeeIndex: dto.employee_index,
    firstName: dto.first_name || '',
    age: dto.age || 0
  }))
}

export class MemberService extends ApiService {
  createMembers(members: Member[]) {
    const membersDTO = mapMembersToDTO(members)

    return this.request({
      method: 'post',
      url: '/members',
      data: { members: membersDTO },
      credentials: true
    }).then((r) => r)
  }

  getMembers() {
    return this.request({
      method: 'get',
      url: '/members',
      credentials: true
    }).then((r) => mapDTOToMembers(r.member))
  }
}
